import { useState, useEffect } from 'react';
import { companyInfo, navLinks } from '@/mocks/multifierros';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  return (
    <div className="fixed top-0 left-0 w-full z-50">
      {/* Logo - conecta ambas barras */}
      <div className="absolute left-4 md:left-8 top-3 md:top-1 z-20">
        <img
          src="https://static.readdy.ai/image/eec6bc8b2f5e3088c7cd7e50ac5ba3da/6436bd4b8916d172780ee495d321479f.png"
          alt="Multifierros Spa - Productos de Acero"
          className="h-8 sm:h-10 md:h-14 w-auto max-w-[100px] sm:max-w-none object-contain drop-shadow-lg"
        />
      </div>

      {/* Top bar - dark */}
      <div className="bg-background-200 border-b border-background-300">
        <div className="max-w-[1280px] mx-auto px-4 md:px-8 pl-28 md:pl-8 pr-14 md:pr-8 flex items-start md:items-center justify-end h-auto md:h-16 min-h-[56px] md:min-h-0 py-2 md:py-0 relative">
          {/* Contact info - se oculta en mobile cuando el menu esta abierto */}
          <div className={`flex-col md:flex-row items-end md:items-center gap-0.5 md:gap-8 text-[10px] md:text-xs text-foreground-300 ${mobileOpen ? 'hidden md:flex' : 'flex'}`}>
            <div className="flex items-center gap-1 whitespace-nowrap">
              <i className="ri-time-line text-xs md:text-sm"></i>
              <span className="hidden md:inline">Lunes a Viernes de 08:00 a 18:00</span>
              <span className="md:hidden">08:00-18:00</span>
            </div>
            <div className="flex items-center gap-1 whitespace-nowrap">
              <i className="ri-phone-line text-xs md:text-sm"></i>
              <a href={`tel:${companyInfo.phones[0].replace(/\s/g, '')}`} className="hover:text-foreground-50 transition-colors">
                {companyInfo.phones[0]}
              </a>
            </div>
            <div className="flex items-center gap-1 whitespace-nowrap">
              <i className="ri-mail-line text-xs md:text-sm"></i>
              <a href={`mailto:${companyInfo.emails[0]}`} className="hover:text-foreground-50 transition-colors">
                {companyInfo.emails[0]}
              </a>
            </div>
          </div>

          {/* Mobile hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden absolute right-3 top-2 w-9 h-9 flex items-center justify-center cursor-pointer text-foreground-200"
            aria-label="Menú"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Nav bar - dark blue */}
      <nav className="bg-primary-950">
        <div className="max-w-[1280px] mx-auto px-4 md:px-8 hidden md:flex items-center justify-end h-12 gap-0">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-white/70 hover:text-white text-xs font-semibold uppercase tracking-wider px-4 py-3 transition-colors whitespace-nowrap cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contacto"
            className="text-white/70 hover:text-white text-xs font-semibold uppercase tracking-wider px-4 py-3 transition-colors whitespace-nowrap cursor-pointer"
          >
            Cotización
          </a>
        </div>
      </nav>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-background-100 border-t border-background-300/40 max-h-[calc(100vh-56px)] overflow-y-auto">
          <div className="px-4 py-5 flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMobileOpen(false)}
                className="text-foreground-200 hover:text-foreground-50 text-sm font-semibold uppercase tracking-wider py-2.5 transition-colors border-b border-background-300/40"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contacto"
              onClick={() => setMobileOpen(false)}
              className="text-foreground-50 text-sm font-semibold uppercase tracking-wider py-2.5 transition-colors mt-1"
            >
              Cotización
            </a>
            <div className="mt-4 pt-4 border-t border-background-300/40 text-foreground-300 text-xs">
              <p className="flex items-center gap-1.5 mb-1">
                <i className="ri-map-pin-line"></i> {companyInfo.address}
              </p>
              <p className="flex items-center gap-1.5">
                <i className="ri-phone-line"></i>
                <a href={`tel:${companyInfo.phones[0].replace(/\s/g, '')}`} className="hover:text-foreground-50 transition-colors">
                  {companyInfo.phones[0]}
                </a>
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}